import React from 'react'
import { ErrorBoundary, useErrorBoundary } from 'react-error-boundary'

import useSWR from 'swr'

import { useToastContext } from '../contexts'
import { FetchError } from '../data/fetchError'
import { FetchResponse } from '../data/fetchResponse'
import { fetchJson } from '../data/fetchers'
import { OrderResponse, WebEdiDto } from '../data/models'
import FallbackErrorMessage from '../utils/errors/FallbackMessage'
import { getHandleableError } from '../utils/errors/isXiaError'

const id = '94c4608c-d291-4170-4d35-08dc853d86a3'

export const TestPage: React.FC = () => {
  return (
    <div className="flex flex-column justify-content-start gap-4 my-4">
      <ErrorBoundary FallbackComponent={FallbackErrorMessage}>
        <div className="border-2 p-2">
          <DataErrorComponent />
        </div>
      </ErrorBoundary>
      <ErrorBoundary FallbackComponent={FallbackErrorMessage}>
        <div className="border-2 p-2">
          <DataComponent />
        </div>
      </ErrorBoundary>
      <ErrorBoundary FallbackComponent={FallbackErrorMessage}>
        <div className="border-2 p-2">
          <ErrorComponent />
        </div>
      </ErrorBoundary>
    </div>
  )
}

const DataErrorComponent: React.FC = () => {
  const { showBoundary } = useErrorBoundary()
  const { data, error } = useSWR<
    FetchResponse<WebEdiDto<OrderResponse>>,
    FetchError
  >(`/DespatchAdvices/${id}`, fetchJson<WebEdiDto<OrderResponse>>, {
    shouldRetryOnError: false,
    revalidateOnFocus: false,
  })

  if (error) showBoundary(error)

  return <div>{JSON.stringify(data)}</div>
}

const ErrorComponent: React.FC = () => {
  throw new Error('Something went horribly wrong')
}

const DataComponent: React.FC = () => {
  const { replaceToast } = useToastContext()
  const { data, error } = useSWR<
    FetchResponse<WebEdiDto<OrderResponse>>,
    FetchError
  >(`/DespatchAdvices/${id}`, fetchJson<WebEdiDto<OrderResponse>>, {
    shouldRetryOnError: false,
    revalidateOnFocus: false,
  })

  if (error) {
    let handleableError = getHandleableError(error)
    let errorMessage = handleableError.message

    replaceToast({
      id: id,
      severity: 'error',
      sticky: true,
      summary: `Error loading DespatchAdvice with ID ${id}`,
      detail: errorMessage,
    })
    return <div>Error Toast</div>
  }

  return <div>{JSON.stringify(data)}</div>
}
